import React from "react";

const Footer = () => {
  return (
    <div>
      <footer>
        <h4>
          &#60;&#47;&#62; with ❤️ & ☕ by{" "}
          <a
            style={{
              textDecoration: "underline",
              color: "white",
            }}
            href="https://github.com/harsh1kashyap"
            target="_blank"
            rel="noreferrer"
          >
            Harshvardhan Jha
          </a>
        </h4>
      </footer>
    </div>
  );
};

export default Footer;
